/**
 * SectionHeader - Reusable section title component with tag, title, divider, and subtitle
 */
import React from 'react';
import AnimatedSection from './AnimatedSection';

const SectionHeader = ({
  tag,
  title,
  subtitle,
  centered = true,
  light = false,
  className = ''
}) => {
  return (
    <div className={`section-header mb-5 ${centered ? 'text-center' : ''} ${className}`}>
      {tag && (
        <AnimatedSection variant="fadeUp" delay={0}>
          <span className="section-tag">{tag}</span>
        </AnimatedSection>
      )}
      <AnimatedSection variant="fadeUp" delay={0.1}>
        <h2 className={`section-title ${light ? 'light' : ''}`}>{title}</h2>
        <div className={`section-divider ${centered ? 'centered' : ''}`}></div>
      </AnimatedSection>
      {subtitle && (
        <AnimatedSection variant="fadeUp" delay={0.2}>
          <p
            className="section-subtitle"
            style={{
              maxWidth: centered ? '600px' : '100%',
              margin: centered ? '0 auto' : '0',
              color: light ? 'rgba(255,255,255,0.75)' : 'var(--color-gray)',
              fontSize: '1.05rem',
              lineHeight: '1.8'
            }}
          >
            {subtitle}
          </p>
        </AnimatedSection>
      )}
    </div>
  );
};

export default SectionHeader;
